const HomeFooter = () => {
  return (
    <div className="home-footer">
      <div className="container">
        <p>© 2021 Storexplore | All Rights Reserved. </p>
      </div>
    </div>
  );
};

export default HomeFooter;
